const resourcesData = [
  {
    id:1,
    academicYear: "2023-2024",
    subjectName:"Malware_Analysis_and_Detection",
    // subjectCode:"CS501",
    // icon:"🌐",
    resources:[
        // {
        //     title:"Syllabus",
        //     type:"PDF",
        //     viewLink:"/resources/WebTechnologies/Syllabus.pdf",
        //     downloadLink:"/resources/WebTechnologies/Syllabus.pdf"
        // },
        
        {
            title:"PPT",
            type:"PDF",
            viewLink:"https://linuxshellscriptingpractice.netlify.app/",
            // downloadLink:"/resources/WebTechnologies/PPT.pdf"
        },
      ]

  },

  {
    id:2,
    academicYear: "2023-2024",
    subjectName:"Ethical Hacking",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Ethical_Hacking_PPT.pdf",
            downloadLink:"E-Resources/Ethical_Hacking_PPT.pdf"
        }
      ]
  },
  {
    id:3,
    academicYear: "2023-2024",
    subjectName:"Computer Organization and Architecture",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"https://sites.google.com/view/amarnathgoudacademichub/coa-ppt-presentations?authuser=0",
            // downloadLink:"/resources/DBMS/PPT.pdf"
        }
      ]
  },
  {
    id:4,
    subjectName:"WEB TECHNOLOGIES",
    academicYear: "2024-2025",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/WEB_TECHNOLOGIES.pdf",
            downloadLink:"E-Resources/WEB_TECHNOLOGIES.pdf"
        }
      ]
  },
  {
    id:5,
    academicYear: "2024-2025",
    subjectName:"Foundations of Cyber Security",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Foundations_of_Cyber_Security.pdf",
            downloadLink:"E-Resources/Foundations_of_Cyber_Security.pdf"
        },
        
      ]
  },
  {
    id:6,
    academicYear: "2024-2025",
    subjectName:"Malware Analysis and Detection",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Malware_Analysis_and_Detection.pdf",
            downloadLink:"E-Resources/Malware_Analysis_and_Detection.pdf"
        },
      ]
  },
  {
    id:7,
    academicYear: "2024-2025",
    subjectName:"Secure Software Engineering",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Secure_Software_Engineering.pdf",
            downloadLink:"E-Resources/Secure_Software_Engineering.pdf"
        }
      ]
  },
  {
    id:8,
    academicYear: "2025-2026",
    subjectName:"Wireless Networking & Mobile Computing",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Wireless Networking & Mobile Computing.pdf",
            downloadLink:"E-Resources/Wireless Networking & Mobile Computing.pdf"
        },
        
      ]
  },
{
    id:9,
    academicYear: "2025-2026",
    subjectName:"Blockchain Technology",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/BlockchainTechnology.pdf",
            downloadLink:"E-Resources/BlockchainTechnology.pdf"
        },
        
      ]
  },
  {
    id:10,
    academicYear: "2025-2026",
    subjectName:"Cryptography and Network security",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Cryptography_and_Network security.pdf",
            downloadLink:"E-Resources/Cryptography_and_Network security.pdf"
        },
        
      ]
  },
  {
    id:11,
    academicYear: "2025-2026",
    subjectName:"COMPUTER NETWORKS",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/COMPUTER_NETWORKS.pdf",
            downloadLink:"E-Resources/COMPUTER_NETWORKS.pdf"
        },
        
      ]
  },
  {
    id:12,
    academicYear: "2025-2026",
    subjectName:"Foundations of Cybersecurity",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Foundations_of_Cybersecurity.pdf",
            downloadLink:"E-Resources/Foundations_of_Cybersecurity.pdf"
        },
        
      ]
  },
  {
    id:13,
    academicYear: "2026-2027",
    subjectName:"Automata Theory and Compiler Design",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Automata Theory and Compiler Design.pdf",
            downloadLink:"E-Resources/Automata Theory and Compiler Design.pdf"
        },
        
      ]
  },
  {
    id:14,
    academicYear: "2026-2027",
    subjectName:"Cloud Security",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Cloud Security.pdf",
            downloadLink:"E-Resources/Cloud Security.pdf"
        },
        
      ]
  },
    {
    id:15,
    academicYear: "2026-2027",
    subjectName:"IOT and SS",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/IOT and SS.pdf",
            downloadLink:"E-Resources/IOT and SS.pdf"
        },
        
      ]
  },
  {
    id:16,
    academicYear: "2026-2027",
    subjectName:"JAVA PROGRAMMING",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/JAVA PROGRAMMING.pdf",
            downloadLink:"E-Resources/JAVA PROGRAMMING.pdf"
        },
        
      ]
  },
{
    id:17,
    academicYear: "2026-2027",
    subjectName:"Database Management System",
    // subjectCode:"CS302",
    // icon:"🗄️",
    resources:[
        {
            title:"PPT",
            type:"PPT",
            viewLink:"E-Resources/Database Management System.pdf",
            downloadLink:"E-Resources/Database Management System.pdf"
        },
        
      ]
  },
  // {
  //   id:1,
  //   subjectName:"Linux & Shell Programming",
  //   subjectCode:"CS501",
  //   icon:"🌐",
  //   resources:[
  //       {
  //           title:"Syllabus",
  //           type:"PDF",
  //           viewLink:"/resources/WebTechnologies/Syllabus.pdf",
  //           downloadLink:"/resources/WebTechnologies/Syllabus.pdf"
  //       },
        
  //       {
  //           title:"PPT",
  //           type:"PDF",
  //           viewLink:"/resources/WebTechnologies/PPT.pdf",
  //           downloadLink:"/resources/WebTechnologies/PPT.pdf"
  //       },
  //       {
  //           title:"Lecture Notes",
  //           type:"PDF",
  //           viewLink:"/resources/WebTechnologies/Notes-1.pdf",
  //           downloadLink:"/resources/WebTechnologies/Notes-1.pdf"
  //       },
  //       {
  //           title:"Lab Manual",
  //           type:"PDF",
  //           viewLink:"/resources/WebTechnologies/LabManual.pdf",
  //           downloadLink:"/resources/WebTechnologies/LabManual.pdf"
  //       },
  //       {
  //           title:"Video Lectures",
  //           type:"VIDEO",
  //           viewLink:"https://www.youtube.com/watch?v=abcdef",
  //           downloadLink:"https://www.youtube.com/watch?v=abcdef"
  //       },
  //       {
  //           title:"NPTEL Course",
  //           type:"LINK",
  //           viewLink:"https://nptel.ac.in/",
  //           downloadLink:"https://nptel.ac.in/"
  //       }

  //   ]

  // },


];

export default resourcesData;